import React from 'react';

export const NoResultsFooter: React.FC<any> = ({ dataTable }) => {
  if (dataTable.rows().length > 0) return null;

  return (
    <tfoot>
      <tr>
        <td colSpan={dataTable.headings().length}>No results found.</td>
      </tr>
    </tfoot>
  );
};
